export interface ResearchReminderTranslation {
    research_reminder_id?: string;
    language: string;
    text: string;
    id?: string;
  }